import { ServerEvent } from "../Stores/Actions/ServerEvent";
import { IHandleResponseError } from "./IHandleResponseError";
import { ResponseIssueConsoleLogger } from "./ResponseIssueConsoleLogger";

/**
 * This class handles common business logic errors received in server responses set in the Errors object the server responses
 */
class GlobalServerResponseErrorHandler {
    private errorHandlers: IHandleResponseError[] = [new ResponseIssueConsoleLogger()];

    public addErrorHandler(handler: IHandleResponseError): void {
        this.errorHandlers.push(handler);
    }

    /**
     * Validate a response, and handle any errors or warnings if needed.
     * @param response The server response to handle.
     * @returns Whether to continue handling the response.
     */
    public handleErrors(response: ServerEvent): boolean {
        let continueResponseHandling = true;

        for (const handler of this.errorHandlers) {
            continueResponseHandling = handler.handleError(response);
            if (!continueResponseHandling)
                break;
        }

        return continueResponseHandling;
    }
}

export { GlobalServerResponseErrorHandler };
